import { GetPaymentInfo } from '../contracts';
import axios, { AxiosError } from 'axios';
import { createAxiosConfig } from '../apiHelpers';
import LogCannon from '@ace-clublabs/log-cannon';
import StatusCode from 'status-code-enum';

export const GetPaymentInfoApi =
  (endpoint: string): GetPaymentInfo =>
  async ({ clubCode, billPlan, membershipNumber, roleCode }) => {
    try {
      const url = `${endpoint}?clubCode=${clubCode}&billPlan=${billPlan}&membershipNumber=${membershipNumber}&roleCode=${roleCode}`;

      const response = await axios.get(url, createAxiosConfig(endpoint));

      LogCannon.blast('GetPaymentInfoApi success');
      return Promise.resolve(response.data.data);
    } catch (e: any | AxiosError) {
      const errorResponse = e?.response?.data?.error;
      LogCannon.blast('GetPaymentInfoApi error', errorResponse);
      return Promise.reject({
        status: 'error',
        error: {
          code: e?.response?.status || StatusCode.ServerErrorInternal,
          message: 'GetPaymentInfoApi failed',
          ...errorResponse,
        },
      });
    }
  };
